import { isMobile } from '@Constants/LeftDrawer';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import { Hoverable } from 'react-native-web-hooks';
import styled from 'styled-components/native';

import { useSeenThingsPresenter } from '../SeenThingsPresenter';

import type { JourneyParameters } from '~types/navigation';

const borderR = isMobile ? '12px' : '20px';

const StyledCardWrapper = styled.Pressable<{
  isHovered?: boolean;
}>`
  width: ${isMobile ? '82px' : '140px'};
  height: ${isMobile ? '82px' : '140px'};
  cursor: pointer;
  position: relative;
  border-radius: ${borderR};
`;

const StyledCardImg = styled.Image`
  height: 100%;
  border-radius: ${borderR};
  object-fit: cover;
  background-position: center;
  z-index: 10;
`;

const StyledCardBox = styled.View<{
  isHovered?: boolean;
}>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;

  border-radius: ${borderR};
  background-color: ${({ isHovered }) =>
    isHovered ? 'rgba(0, 0, 0, 0.20)' : 'rgba(0, 0, 0, 0.05)'};
`;

type Props = {
  url: string;
  path?: JourneyParameters;
};

const SeenThingsCard: FC<Props> = ({ url, path }) => {
  const { navigateToProductDetail } = useSeenThingsPresenter();
  return (
    <Hoverable>
      {(isHovered) => (
        <StyledCardWrapper onPress={() => navigateToProductDetail(path)}>
          <StyledCardImg key={url} resizeMode='contain' source={{ uri: url }} />
          <StyledCardBox isHovered={isHovered} />
        </StyledCardWrapper>
      )}
    </Hoverable>
  );
};

export default observer(SeenThingsCard);
